<template>
  <div class="mx-auto my-5">
    <b-container>
      <b-row>
        <b-col cols=6>
          Email: 
          <b-form-input disabled v-model="email" type="email" class="form-control"></b-form-input>
        </b-col>
        <b-col cols=6>
          Institution:
          <b-form-input disabled v-model="institution" class="form-control"></b-form-input>
        </b-col>
        <b-col cols=6>
          First Name:
          <b-form-input disabled v-model="first" class="form-control"></b-form-input>
        </b-col>
        <b-col cols=6>
          Last Name:
          <b-form-input disabled v-model="last" class="form-control"></b-form-input>
        </b-col>
        <b-col cols=12 class="mt-5">
          API Access Token
          <b-button @click="genToken">Generate</b-button>
          <b-button variant="success" v-clipboard:copy="token">
            <icon name="clipboard" class="align-middle"></icon>
          </b-button>
          <b-form-input v-model="token" disabled class="form-control mt-2"></b-form-input>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      institution: '',
      first: '',
      last: '',
      token: ''
    }
  },

  methods: {
    fetchUser () {
      this.$http.get('/user/user')
      .then(res => {
        this.email = res.data.email
        this.institution = res.data.institution
        this.first = res.data.firstName
        this.last = res.data.lastName
        this.token = ''
      })
    },

    genToken () {
      this.$http.get('/user/api_token')
      .then(res => {
        this.token = res.data.token
        console.log(res)
      })
    }
  },

  mounted () {
    this.fetchUser()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
